<template>
  <div>
    <div class="row">
      <div class="col-12">
        <QuoteBreakdownWidget :filter="filter" :gridHeight="260" />        
      </div>
    </div>

  </div>
</template>


<script>
import _ from 'lodash'
import moment from 'moment'

import DashboardTitle from '@/components/dashboard/dashboardTitle'
import DashboardContentBox from '@/components/dashboard/dashboardContentBox'
import DashboardTabbedContentBox from '@/components/dashboard/dashboardTabbedContentBox'
import AnalyticsDashboardHeader from '@/modules/intelligence/components/analyticsDashboardHeader'
import AnalyticsWidget from '@/modules/intelligence/components/analyticsWidget'
import AnalyticsReportLink from '@/modules/intelligence/components/analyticsReportLink'
import AnalyticsDashboardValue from '@/modules/intelligence/components/analyticsDashboardValue'

import QuoteBreakdownWidget from '@/modules/intelligence/dashboardWidgets/quoteBreakdownWidget'

export default {
  name: 'AnalyticsQuotesDashboard',
  components: {
    DashboardTitle,
    DashboardContentBox,
    DashboardTabbedContentBox,
    AnalyticsDashboardHeader,
    AnalyticsWidget,
    AnalyticsReportLink,
    AnalyticsDashboardValue,
    QuoteBreakdownWidget
  },
  props: {
    filter: Object
  },
  data() {
    return {
      
    }
  },
  created() {
    
  },
  mounted() {
    
  },
  methods: {
    
  }
  
}
</script>